import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { FeatureFlagService } from '@galaxy/partner';
import { Observable, of } from 'rxjs';
import { filter, map, switchMap, take } from 'rxjs/operators';
import { AppConfigService } from '../../app-config.service';
import { UnifiedTOSService } from '../tos-unified.service';

@Injectable({ providedIn: 'root' })
export class EmbedGuard {
  signupUrl = '/signup';
  newSignUpUrl = '/sign-up';
  tosUrl = '/terms-of-service';
  testLogin = '/login-two';

  constructor(
    private router: Router,
    private configService: AppConfigService,
    private unifiedTOSService: UnifiedTOSService,
    private feature: FeatureFlagService,
  ) {}

  canActivate(route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> {
    const redirectUrl: string = route.queryParams.embed || '/';
    if (
      redirectUrl.indexOf(this.signupUrl) === 0 ||
      redirectUrl.indexOf(this.newSignUpUrl) === 0 ||
      redirectUrl.indexOf(this.testLogin) === 0
    ) {
      return this.allowNavigation(redirectUrl);
    }
    return this.redirectToUnifiedTOS().pipe(
      take(1),
      switchMap((redirectToUnifiedTOS) => {
        if (redirectToUnifiedTOS) {
          this.router.navigateByUrl(this.tosUrl, { replaceUrl: true });
          return of(false);
        }
        return this.allowNavigation(redirectUrl);
      }),
    );
  }

  allowNavigation(redirectUrl: string): Observable<boolean> {
    this.router.navigateByUrl(redirectUrl, { replaceUrl: true });
    return of(false);
  }

  redirectToUnifiedTOS(): Observable<boolean> {
    return this.unifiedTOSService.tosDataLoaded$
      .pipe(
        filter((isReady) => isReady === true),
        take(1),
      )
      .pipe(
        map(() => {
          return this.unifiedTOSService.isClassicSubscription && !this.configService.config.acceptedTermsAndConditions;
        }),
      );
  }
}
